// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { Loader } from '@speeki/global-ui-components';
import { IconButton, IconManager } from '@speeki/icons';

import {
    CloseIconWrapper,
    LanguageSelectInfo,
    MobileLanguageLabel,
    MobileLanguageList,
    MobileLanguageListWrapper,
    MobileListTitle,
    SelectButton,
    SelectItem,
    SelectText,
    SelectWrapper,
} from '@components/molecules/LanguageSelect/LanguageSelect.styled';
import { useLanguageSelect } from '@components/molecules/LanguageSelect/useLanguageSelect';

import { languagesOptions } from '@utils/dictionary';

import { useReactiveVar } from '@apollo/client';
import { currentLanguageVar } from '@boot/reactiveVariables';

export interface MobileLanguageSelectProps {
    className?: string;
}

export const MobileLanguageSelect = ({
    className,
}: MobileLanguageSelectProps) => {
    const { t } = useTranslation();

    const { isDisabled, isOpen, loading, onChange, selectRef, setIsOpen } =
        useLanguageSelect();
    const currentLanguage = useReactiveVar(currentLanguageVar);

    return (
        <SelectWrapper className={className}>
            <SelectButton
                data-testid="PVZWtO-"
                onClick={() => !isDisabled && setIsOpen(true)}
            >
                {loading ? (
                    <Loader color="text_assistive" size={24} />
                ) : (
                    <IconManager icon={'SvgLanguage24'} size={24} />
                )}
                <MobileLanguageLabel
                    data-testid="uKWU1Mm"
                    isDisabled={isDisabled}
                >
                    {currentLanguage}
                </MobileLanguageLabel>
            </SelectButton>
            <AnimatePresence>
                {isOpen && (
                    <MobileLanguageListWrapper
                        animate={{
                            x: 40,
                        }}
                        exit={{
                            x: '100vw',
                        }}
                        initial={{
                            x: '100vw',
                        }}
                        ref={selectRef}
                        transition={{ type: 'tween' }}
                    >
                        <CloseIconWrapper>
                            <IconButton
                                iconProps={{
                                    icon: 'SvgClose24',
                                    size: 24,
                                }}
                                onClick={() => setIsOpen(false)}
                                testId="-knSfS8"
                            />
                        </CloseIconWrapper>
                        <MobileListTitle>
                            {t('CHANGE_LANGUAGE')}
                        </MobileListTitle>
                        <LanguageSelectInfo>
                            {t('CHANGE_LANGUAGE_INFO')}
                        </LanguageSelectInfo>
                        <MobileLanguageList>
                            {languagesOptions.map(({ key, label, value }) => {
                                const isActive = currentLanguage === value;

                                return (
                                    <SelectItem
                                        data-testid={`wa212a-${value}`}
                                        key={key}
                                        onClick={() => onChange(value)}
                                    >
                                        <SelectText isActive={isActive}>
                                            {label}
                                        </SelectText>
                                        {isActive && (
                                            <IconManager
                                                icon={'SvgTick24'}
                                                size={24}
                                                themeColors={{
                                                    default: {
                                                        'color-1':
                                                            'main.primary',
                                                    },
                                                }}
                                            />
                                        )}
                                    </SelectItem>
                                );
                            })}
                        </MobileLanguageList>
                    </MobileLanguageListWrapper>
                )}
            </AnimatePresence>
        </SelectWrapper>
    );
};
